import Rule from './rule';

export default class ReplaceRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'REPLACE';
    this.subType = 'DEFAULT';
    this.whole = false;
    this.compile(ruleText);
  }

  compile(text) {
    let flag = '';
    let rule = '';
    if (text.search('--whole')) {
      this.whole = true;
      text = text.replace(/\s?--whole/i, '');
    }
    if (/^\s?replace --first/i.test(text)) {
      this.subType = 'FIRST';
      rule = text.replace(/^\s?replace --first/i, '');
    } else if (/^\s?replace --last/i.test(text)) {
      this.subType = 'LAST';
      rule = text.replace(/^\s?replace --last/i, '');
    } else if (/^\s?replace --empty/i.test(text)) {
      this.subType = 'EMPTY';
      rule = text.replace(/^\s?replace --empty/i, '');
    } else if (/^\s?replace --filled/i.test(text)) {
      this.subType = 'FILLED';
      rule = text.replace(/^\s?replace --filled/i, '');
    } else {
      flag = 'g';
      rule = text.replace(/^\s?replace/i, '');
    }

    const args = rule.split(/with/i).map(arg => arg.trim());
    this.stringArgs = [args[0], args[1]];
    try {
      // If a rule contains a token it gets placed between brackets so its used as a literal instead of a regex token.
      if(/^[\W]$/.test(args[0])) {
        args[0] = `[${args[0]}]`;
      }
      const reg = new RegExp(args[0], flag);
      this.args = [reg, args[1]];
    } catch (e) {
      this.args = [];
    }
  }

  run(input, headers, resolve) {

    let arg = this.args[1];

    if (arg.toLowerCase().trim() === '--empty') {
      arg = '';
    }

    const inputString = `${input}`;
    this.args[0] = this.args[0].toString().replace('/g', '').replace('/', '');
    let replaceValue = this.args[0];
    if (headers.includes(this.args[1])) {
      replaceValue = resolve(this.args[1])
      arg = resolve(this.args[1])
    }
    switch (this.subType) {
      case 'FIRST':
        return this.whole ? inputString.replace(new RegExp(`\b${this.args[0]}\b`), arg) : inputString.replace(this.args[0], arg);
      case 'LAST':
        const index = inputString.lastIndexOf(replaceValue);
        return this.whole ? inputString.slice(0, index) + inputString.slice(index).replace(new RegExp(`\b${replaceValue}\b`), arg) : inputString.slice(0, index) + inputString.replace(replaceValue, arg);
      case 'EMPTY':
        return inputString.length === 0 ? arg : inputString;
      case 'FILLED':
        return inputString ? arg : inputString;
      default:
        return this.whole ? inputString.replace(new RegExp(`\\b${this.args[0]}\\b`), arg) : inputString.replace(this.args[0], arg);
    }
  }

  validate() {
    if (this.subType === 'EMPTY' || this.subType === 'FILLED') {
      return /with/i.test(this.ruleText) && this.args.length === 2 && this.stringArgs.some(arg => arg === '');
    }

    return /with/i.test(this.ruleText) && this.args.length === 2 && !this.stringArgs.some(arg => arg === '');
  }
}
